import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 21l-9.079-2.894c-.564-.18-.921-.548-.921-.95V5.719c0-.79 1.304-1.303 2.412-.95L12 7.188M12 21l9.304-2.965a1 1 0 00.696-.953V5.368a1 1 0 00-1.304-.952L12 7.188M12 21V7.188M17 11v2m0 0v2m0-2h-2m2 0h2"
    })
  ]))
}